<template>
    <div>
<!--        <HelloWorld msg="Welcome to Your Vue.js App"/>-->
        <div
                :class="['layer', [menuIsToggle ? 'is-active': '']]"
                @click="hideMenu"
        >
        </div>
        <header class="header main__header">
            <div class="header__top">
                <v-container class="d-flex justify-space-between align-center">
                    <logo :width="104" :height="24" class="d-flex align-center"/>
                    <div class="header__hamburger">
                        <Hamburger
                                :showMenu="menuIsToggle"
                                @toggle="toggleMenu"/>
                    </div>
                    <div class="d-flex align-center header__action"
                         :class="menuIsToggle ? 'is-active': ''"
                    >
                        <p class="header__top-title font-reg">{{$t("landing.header.have_account")}}</p>
                        <router-link to="/members/dashboard" class="btn btn-sm btn-gradient header__button">
                            <span>{{$t("landing.header.login_button")}}</span>
                        </router-link>
                        <router-link to="/members/sign-up" class="btn btn-sm btn-reg header__button">
                                <span>{{$t("landing.header.reg_button")}}</span>
                        </router-link>
                    </div>
                </v-container>
            </div>
        </header>

        <section class="first">
            <v-container>
                <p class="first__h1">{{$t("landing.first.title")}}</p>
                <p class="first__h2">{{$t("landing.first.subtitle")}}</p>
                <p class="first__description flex lg6">{{$t("landing.first.description")}}</p>
                <router-link to="/members/dashboard" class="btn btn-sm btn-gradient">
                    <span>{{$t("landing.first.login_button")}}</span>
                </router-link>
            </v-container>

            <section class="second">
                <div class="container">
                    <div class="second__inner">
                        <p class="second__text" v-html="$t('landing.second.first_text')">
                        </p>

                        <p class="second__text" v-html="$t('landing.second.second_text')">
                        </p>
                    </div>
                </div>
            </section>
        </section>



        <section class="preview">
            <p class="third__title">{{$t('landing.preview.title')}}</p>
            <div class="preview__inner">
                <div class="preview__video">
<!--                    <a href="#" class="preview__video-play"></a>-->
                </div>
                <div class="preview__content">
                    <ul class="steps">
                        <li class="steps__item">
                            <div class="steps__num font-semi">1</div>
                            <div class="steps__text font-reg">
                                {{$t('landing.preview.instructions.first_step_1')}}<br>
                                {{$t('landing.preview.instructions.first_step_2')}}
                            </div>
                        </li>
                        <li class="steps__item">
                            <div class="steps__num font-semi">2</div>
                            <div class="steps__text font-reg">
                                {{$t('landing.preview.instructions.second_step')}}
                            </div>
                        </li>
                        <li class="steps__item">
                            <div class="steps__num font-semi">3</div>
                            <div class="steps__text font-reg">
                                {{$t('landing.preview.instructions.third_step')}}
                            </div>
                        </li>
                        <li class="steps__item">
                            <div class="steps__num font-semi">4</div>
                            <div class="steps__text font-reg">
                                {{$t('landing.preview.instructions.fourth_step')}}
                            </div>
                        </li>
                    </ul>
                    <div class="preview__content-subtitle">
                        {{$t('landing.preview.instructions.subtitle')}}
                    </div>
                </div>
            </div>
        </section>



        <section class="fourth">
            <p class="third__title">{{$t('landing.fourth.title')}}</p>

            <div class="container d-flex justify-lg-space-around align-center flex-wrap">
<!--                <a href="#" class="flex lg3 md3 sm6 xs6 d-flex justify-center align-center fourth__item"><img src="@/assets/images/logos/activ.png" alt=""></a>-->
                <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center align-center fourth__item"><img src="@/assets/images/logos/elements.png" alt=""></a>
                <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center align-center fourth__item"><img src="@/assets/images/logos/injoy.png" alt=""></a>
                <a href="#" class="flex lg4 md4 sm4 xs4 d-flex justify-center align-center fourth__item"><img src="@/assets/images/logos/injoy_xpress.png" height="120" alt=""></a>
                <div class="fourth__border"></div>
            </div>
        </section>

        <section class="fifth d-flex justify-center align-center ">
            <div class="fifth__container container">
                <logo :width="174" :height="40"/>
                <p class="fifth__title">{{$t('landing.fifth.title')}}</p>
                <p class="fifth__subtitle">{{$t('landing.fifth.subtitle')}}</p>

                <div class="fifth__action d-flex justify-center align-center flex-column">
                    <router-link to="/studios/dashboard" class="fifth__btn btn btn-sm btn-gradient">
                        <span>{{$t('landing.fifth.button')}}</span>
                    </router-link>

                    <a href="mailto:oms@aciso.com?subject=Multitraining-Account" target="_blank" class="members-link mt-3">
                        <span>{{$t('landing.fifth.link')}}</span>
                    </a>
                </div>

            </div>
        </section>

        <Footer :is-light="true" :is-member="true" class="main__footer"/>
    </div>
</template>

<script>
    // import HelloWorld from '@/components/HelloWorld.vue';
    import Footer from '../components/studios/StudioFooter';
    import Hamburger from '@/elements/hamburger'
    export default {
        data() {
            return {
                menuIsToggle: false
            }
        },
        components: {
            // HelloWorld
            Hamburger,
            Footer
        },
        methods: {
            toggleMenu(val) {
                this.menuIsToggle = val
            },
            hideMenu() {
                this.menuIsToggle = false
            }
        }

    }
</script>

<style lang="sass" scoped>
    .header
        z-index: 100
        width: 100%
        top: 0
        left: 0
        +sm
            position: fixed
        &__action
            transition: opacity .3s ease, transform .3s ease
            +sm
                border-top: 1px solid rgba($color--white, 0.15)
                position: absolute
                top: 100%
                z-index: 11
                flex-direction: column
                width: 100%
                left: 0
                right: 0
                background: $color--dark
                padding: 40px 16px
                opacity: 0
                visibility: hidden
                transition: all .3s ease
            &.is-active
                opacity: 1
                visibility: visible

        &__button
            min-width: 150px
            padding: 0 10px
            height: 40px
            margin-left: 24px
            +sm
                min-width: 100%
                margin: 24px 0 0 0
        &__hamburger
            display: flex
            +rmin(768)
                display: none
    .main
        &__header
            .header__top
                padding: 8px 0
                +xs
                    padding: 0
                    .container
                        padding: 10px 12px
                &-title
                    font-size: 14px
                    line-height: 16px
                    color: $color--white


        &__footer
            background: $color--dark
            border-top: 1px solid #304466 !important

            &::v-deep
                .footer__copy
                    color: red
    .first
        background-image: url("~@/assets/images/landing/landingFirst.jpg")
        background-repeat: no-repeat
        background-size: cover
        background-position: 50% 50%
        position: relative
        padding-bottom: 243px
        +md
            padding-bottom: 150px
        +r(360)
            padding-bottom: 170px
        &::before
            content: ''
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: 0
            height: 100%
            background: linear-gradient(265deg, rgba(6, 30, 71, 0.78) 2.21%, rgba(23, 66, 124, 0.64) 135.57%)
            opacity: 0.87
            z-index: 1

        .container
            position: relative
            z-index: 3
            color: $color--white
            height: 100%
            font-size: 16px
            +md
                font-size: 12.5px
            +xs
                font-size: 6.4px

        &__h1,
        &__h2
            font-size: em(72)
            letter-spacing: 0.08em
            line-height: 1
            +xs
                text-align: center

        &__h1
            margin-top: em(30)
            +bold

        &__h2
            +reg
            margin-top: 10px

        &__description
            +reg
            font-size: 18px
            letter-spacing: 0.01em
            line-height: 28px
            margin: 30px 0 40px 0
            +xs
                margin: 14px 0 24px 0
                font-size: 14px
                text-align: center

    .second
        position: absolute
        top: 102%
        transform: translateY(-50%)
        z-index: 2
        left: 0
        right: 0
        margin: 0 auto

        &__text
            +reg
            font-size: 18px
            line-height: 27px
            letter-spacing: 0.5px
            color: $color--dark
            +r(991)
                font-size: 14px
                line-height: 24px
            +xs
                font-size: 12px
                line-height: 20px
            &:first-child
                margin-bottom: 30px
        &__inner
            background: #fff
            box-shadow: 0 8px 16px rgba(11, 35, 75, 0.12)
            border-radius: 2px
            padding: 40px 38px
            z-index: 4
            position: relative
            +r(991)
                padding: 24px
            +xs
                padding: 16px 10px

    .preview
        padding-top: 267px
        +md
            padding-top: 200px
        &__inner
            display: flex
            width: 100%
            +r(991)
                flex-direction: column
        &__video
            width: 57%
            +cover
            background-image: url("~@/assets/images/landing/video-bg.jpg")
            display: flex
            justify-content: center
            align-items: center
            &-play
                width: 99px
                height: 99px
                background-image: url("~@/assets/images/landing/play.png")
                +cover
                +xs
                    width: 45px
                    height: 45px
            +r(991)
                height: 609px
            +xs
                height: 250px
        &__content
            background: #0B234B
            padding: 60px 105px
            width: 50%
            +r(1199)
                padding: 60px
            +r(991)
                padding: 48px
            +xs
                padding: 40px 12px
            &-subtitle
                letter-spacing: 0.5px
                font-size: 14px
                line-height: 24px
                color: rgba($color--white, 0.5)
                margin-top: 24px
                max-width: 350px
                +reg
                +r(991)
                    margin: 16px auto 0
        &__video,
        &__content
            +r(991)
                width: 100%
                text-align: center
    .steps
        display: flex
        padding: 0
        flex-direction: column
        list-style-type: none
        color: $color--white
        +r(991)
            justify-content: center
            align-items: center
        &__item
            max-width: 419px
            width: 100%
            &:not(:first-child)
                margin-top: 35px
        &__num
            width: 48px
            height: 48px
            border: 1px solid $color--flame
            display: flex
            font-size: 24px
            justify-content: center
            align-items: center
            border-radius: 50%
            +r(991)
                margin: 0 auto
        &__text
            font-size: 18px
            line-height: 28px
            margin-top: 12px
            +xs
                font-size: 16px


    .third
        &__title
            margin-bottom: 48px
            +bold
            text-align: center
            font-size: 48px
            line-height: 56px
            letter-spacing: 2px
            color: $color--dark
            +r(991)
                margin-bottom: 40px
            +xs
                font-size: 24px
                margin-bottom: 24px
                line-height: 33px


    .fourth
        padding: 120px 0 140px
        position: relative

        &__item
            border-right: 1px solid rgba(#0B234B, 0.15)
            img
              max-width: 210px !important

            +r(959)
                &:nth-child(1), &:nth-child(2)
                    margin-bottom: 25px

                &:nth-child(3), &:nth-child(4)
                    margin-top: 25px

                &:nth-child(2)
                    border-right: none

            &:last-of-type
                border-right: none

        &__border
            display: none
            +r(959)
                display: block
                width: calc(100% - 24px)
                height: 1px
                position: absolute
                top: 55%
                transform: translateY(-50%)
                background: rgba(#0B234B, 0.15)

            +r(599)
                top: 53%




    .fifth
        height: 500px
        background-image: url("~@/assets/images/landing/landingFifth.jpg")
        background-repeat: no-repeat
        background-size: cover
        background-position: 50% 50%
        position: relative
        color: $color--white
        text-align: center

        &::before
            content: ''
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: 0
            height: 500px
            background: linear-gradient(265deg, rgba(6, 30, 71, 0.78) 2.21%, rgba(23, 66, 124, 0.64) 135.57%)
            opacity: 0.87
            z-index: 1

        &__container
            z-index: 4

        &__title
            margin: 32px 0 16px
            +bold
            font-size: 32px
            line-height: 38px
            letter-spacing: 0.05em

        &__subtitle
            margin-bottom: 48px
            +medium
            font-size: 18px
            line-height: 24px
            letter-spacing: 1px

        +r(599)
            text-align: center
        &__btn
            max-width: 350px

    .container
        +rmin(1264)
            max-width: 1160px

    .layer
        position: fixed
        top: 0
        left: 0
        background: rgba($color--dark, 0.6)
        width: 100%
        height: 100%
        z-index: 11
        opacity: 0
        visibility: hidden
        transition: all .3s ease
        +rmin(768)
            display: none
        &.is-active
            opacity: 1
            visibility: visible

    .members-link
        &:hover
            text-decoration: underline
</style>
